<div class="billing-control page-b4a">
  <div class="billing-control__header">
    <div class="billing-control__title-row">
      <h1>Controle de Cobrança</h1>
      <i
        class="pi pi-question-circle billing-control__help"
        [pTooltip]="tips.page"
        tooltipPosition="right"
      ></i>
    </div>
    <p class="billing-control__subtitle">
      Acompanhe a rodada e veja em que etapa cada assinante está.
    </p>
  </div>

  <section class="billing-control__analysis" *ngIf="paymentRounds.length > 0">
    <div class="billing-control__analysis-toolbar">
      <div class="billing-control__round-picker">
        <label for="billing-round-select">
          Analisando a rodada
          <i
            class="pi pi-question-circle billing-control__help"
            pTooltip="Escolha qual rodada de cobrança você quer analisar."
            tooltipPosition="top"
          ></i>
        </label>
        <p-dropdown
          inputId="billing-round-select"
          [options]="roundOptions"
          [(ngModel)]="selectedRoundId"
          (onChange)="onRoundChange($event.value)"
          placeholder="Selecione uma rodada"
          [style]="{ minWidth: '16rem' }"
        />
      </div>

      <div class="billing-control__toolbar-actions">
        <p-tag
          *ngIf="runningStatus?.running"
          severity="warning"
          value="Cobrança em andamento"
          icon="pi pi-spin pi-spinner"
        />
        <span
          class="billing-control-health"
          [class.billing-control-health--healthy]="health === 'healthy'"
          [class.billing-control-health--attention]="health === 'attention'"
          [class.billing-control-health--critical]="health === 'critical'"
          [class.billing-control-health--unknown]="health === 'unknown'"
        >
          {{ healthLabel }}
          <i
            class="pi pi-question-circle billing-control-health__help"
            [pTooltip]="tips.health"
            tooltipPosition="top"
          ></i>
        </span>

        <button
          pButton
          type="button"
          label="Atualizar"
          icon="pi pi-refresh"
          class="p-button-text"
          [disabled]="isSummaryLoading || isActionLoading"
          (click)="refreshAnalysis()"
        ></button>
        <button
          pButton
          type="button"
          label="Relatório"
          icon="pi pi-chart-bar"
          class="p-button-outlined"
          [disabled]="!selectedRoundId"
          (click)="openReport()"
        ></button>
        <button
          pButton
          type="button"
          label="Ver falhas"
          icon="pi pi-exclamation-triangle"
          class="p-button-outlined p-button-warning"
          [disabled]="!selectedRoundId"
          (click)="openErrorReport()"
        ></button>
        <button
          pButton
          type="button"
          label="Pausar cobrança"
          icon="pi pi-pause"
          class="p-button-danger p-button-outlined"
          *ngIf="runningStatus?.running"
          [disabled]="isActionLoading"
          (click)="confirmPause($event)"
        ></button>
        <button
          pButton
          type="button"
          label="Retomar cobrança"
          icon="pi pi-play"
          class="p-button-success p-button-outlined"
          *ngIf="runningStatus && !runningStatus.running"
          [disabled]="isActionLoading"
          (click)="confirmResume($event)"
        ></button>
      </div>
    </div>

    <p class="billing-control__empty" *ngIf="!selectedRoundId">
      Selecione uma rodada para analisar.
    </p>

    <ng-container *ngIf="selectedRoundId && selectedSummary">
      <div class="billing-control__kpi-grid">
        <article class="billing-control__kpi">
          <span class="billing-control__kpi-label">
            Assinantes nesta rodada
            <i
              class="pi pi-question-circle billing-control__help"
              [pTooltip]="tips.pipeline"
              tooltipPosition="top"
            ></i>
          </span>
          <span class="billing-control__kpi-value">{{
            (selectedSummary.totalSubscribers ?? 0) | number
          }}</span>
        </article>
        <article class="billing-control__kpi">
          <span class="billing-control__kpi-label">
            Previsto no início
            <i
              class="pi pi-question-circle billing-control__help"
              [pTooltip]="tips.snapshot"
              tooltipPosition="top"
            ></i>
          </span>
          <span class="billing-control__kpi-value">{{
            (selectedSummary.subscriberCount ?? 0) | number
          }}</span>
        </article>
        <article class="billing-control__kpi">
          <span class="billing-control__kpi-label">
            Pagamentos confirmados
            <i
              class="pi pi-question-circle billing-control__help"
              pTooltip="Pessoas com pagamento realmente confirmado."
              tooltipPosition="top"
            ></i>
          </span>
          <span class="billing-control__kpi-value">{{
            (selectedSummary.paymentSuccess ?? 0) | number
          }}</span>
        </article>
        <article class="billing-control__kpi">
          <span class="billing-control__kpi-label">
            Taxa de aprovação
            <i
              class="pi pi-question-circle billing-control__help"
              [pTooltip]="tips.approval"
              tooltipPosition="top"
            ></i>
          </span>
          <span class="billing-control__kpi-value"
            >{{ approvalRate | number: '1.1-1' }}%</span
          >
        </article>
        <article class="billing-control__kpi">
          <span class="billing-control__kpi-label">Finalizados</span>
          <span class="billing-control__kpi-value">{{
            (selectedSummary.finished ?? 0) | number
          }}</span>
        </article>
        <article
          class="billing-control__kpi billing-control__kpi--alert"
          *ngIf="noTokenCount > 0"
          role="button"
          tabindex="0"
          (click)="openNoTokenView()"
          (keydown.enter)="openNoTokenView()"
        >
          <span class="billing-control__kpi-label">
            Sem token
            <i
              class="pi pi-question-circle billing-control__help"
              [pTooltip]="tips.noToken"
              tooltipPosition="top"
            ></i>
          </span>
          <span class="billing-control__kpi-value">{{ noTokenCount | number }}</span>
          <span class="billing-control__kpi-hint">Clique para ver a lista</span>
        </article>
      </div>

      <div class="billing-control__funnel">
        <div class="billing-control__funnel-heading">
          <h2>
            Etapas da cobrança
            <i
              class="pi pi-question-circle billing-control__help"
              [pTooltip]="tips.funnel"
              tooltipPosition="top"
            ></i>
          </h2>
          <p class="billing-control__funnel-order">
            Ordem: Validação → Cobrança → Falha/Pago → Ativação → Edição →
            Finalizado
          </p>
        </div>
        <div class="billing-control__kpi-grid billing-control__funnel-grid">
          <button
            type="button"
            class="billing-control__kpi billing-control__kpi--clickable"
            *ngFor="let card of funnelCards"
            (click)="goToStepTab(card.tabIndex)"
          >
            <span class="billing-control__kpi-label">
              <span class="billing-control__step-num">{{ card.step + 1 }}</span>
              {{ card.label }}
              <i
                class="pi pi-question-circle billing-control__help"
                [pTooltip]="card.tip"
                tooltipPosition="top"
                (click)="$event.stopPropagation()"
              ></i>
            </span>
            <span class="billing-control__kpi-value">{{ card.count | number }}</span>
          </button>
        </div>
      </div>
    </ng-container>
  </section>

  <p-tabView [(activeIndex)]="activeStepIndex" styleClass="billing-control__tabs">
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="billing-control__tab-header billing-control__tab-header--home">
          Rodadas
          <i
            class="pi pi-question-circle billing-control__help"
            [pTooltip]="tips.roundsTab"
            tooltipPosition="top"
          ></i>
        </span>
      </ng-template>

      <div class="billing-control__howto">
        <p class="billing-control__howto-title">Como funciona</p>
        <ol class="billing-control__howto-list">
          <li><strong>Criar rodada</strong> — só registra ou agenda o ciclo (ainda não cobra).</li>
          <li><strong>Iniciar cobrança</strong> — coloca as pessoas no funil.</li>
          <li>
            <strong>Acompanhar as etapas</strong> — Validação → Cobrança →
            Falha/Pago → Ativação → Edição → Finalizado.
          </li>
        </ol>
      </div>

      <div class="billing-control__actions">
        <div class="billing-control__actions-group">
          <span class="billing-control__actions-label">Ciclo</span>
          <button
            pButton
            type="button"
            label="Criar rodada"
            icon="pi pi-plus"
            class="p-button-outlined"
            [disabled]="isActionLoading"
            pTooltip="Cria ou agenda uma nova rodada. Ainda não inicia a cobrança."
            tooltipPosition="top"
            (click)="openCreatePaymentRoundDialog()"
          ></button>
          <button
            pButton
            type="button"
            label="Iniciar cobrança"
            icon="pi pi-play"
            class="p-button-success"
            [disabled]="isActionLoading"
            pTooltip="Inicia o ciclo: as pessoas entram na Validação e seguem o funil."
            tooltipPosition="top"
            (click)="confirmStartPaymentRound($event)"
          ></button>
          <button
            pButton
            type="button"
            label="Atualizar lista"
            icon="pi pi-refresh"
            class="p-button-text"
            [disabled]="isActionLoading"
            (click)="loadPaymentRounds()"
          ></button>
        </div>
        <div class="billing-control__actions-group">
          <span class="billing-control__actions-label">Configuração</span>
          <button
            pButton
            type="button"
            label="Ordem de cobrança"
            icon="pi pi-sort-alt"
            class="p-button-outlined"
            (click)="openPaymentPriorityDialog()"
          ></button>
          <button
            pButton
            type="button"
            label="Ordem de gateway"
            icon="pi pi-sitemap"
            class="p-button-outlined"
            (click)="openGatewayPriorityDialog()"
          ></button>
        </div>
      </div>

      <section class="billing-control__section">
        <h2>
          Lista de rodadas
          <i
            class="pi pi-question-circle billing-control__help"
            pTooltip="Cada rodada é um ciclo de cobrança. Use o olho para analisar no painel acima."
            tooltipPosition="top"
          ></i>
        </h2>
        <app-table
          *ngIf="paymentRounds.length > 0"
          [lazy]="false"
          [elements]="paymentRounds"
          [cols]="paymentRoundCols"
          [actionButtons]="paymentRoundActions"
          [addButton]="false"
          [exportExcel]="false"
          [exportPdf]="false"
          [showTitle]="false"
          modelName="rodadas de cobrança"
          sortField="paymentRoundId"
          [sortOrder]="-1"
        />
        <div class="billing-control__empty" *ngIf="paymentRounds.length === 0">
          Nenhuma rodada encontrada. Crie a primeira rodada para começar.
        </div>
      </section>
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="billing-control__tab-header">
          <span class="billing-control__step-num billing-control__step-num--tab">1</span>
          Validação
          <i
            class="pi pi-question-circle billing-control__help"
            [pTooltip]="tips.validation"
            tooltipPosition="top"
          ></i>
        </span>
      </ng-template>
      <app-billing-control-subscriber-steps
        [step]="0"
        titleLabel="Validação"
        cronJobName="validation-producer"
        [paymentRoundId]="selectedRoundId"
        description="Primeira etapa depois de iniciar a cobrança: checagens antes de tentar cobrar no cartão."
      />
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="billing-control__tab-header">
          <span class="billing-control__step-num billing-control__step-num--tab">2</span>
          Cobrança
          <i
            class="pi pi-question-circle billing-control__help"
            [pTooltip]="tips.payment"
            tooltipPosition="top"
          ></i>
        </span>
      </ng-template>
      <app-billing-control-subscriber-steps
        [step]="1"
        titleLabel="Cobrança"
        cronJobName="payment-producer"
        [paymentRoundId]="selectedRoundId"
        description="Tentativa de pagamento. “Na fila” ainda vai cobrar; “Já tentou” aguarda retorno do cartão."
      />
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="billing-control__tab-header">
          <span class="billing-control__step-num billing-control__step-num--tab">3</span>
          Falha
          <i
            class="pi pi-question-circle billing-control__help"
            [pTooltip]="tips.failed"
            tooltipPosition="top"
          ></i>
        </span>
      </ng-template>
      <app-billing-control-subscriber-steps
        [step]="2"
        titleLabel="Falha"
        [paymentRoundId]="selectedRoundId"
        description="Step FAILED (2): falha terminal após esgotar gateways, cartão backup e anual→mês."
      />
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="billing-control__tab-header">
          <span class="billing-control__step-num billing-control__step-num--tab">4</span>
          Pago
          <i
            class="pi pi-question-circle billing-control__help"
            [pTooltip]="tips.paid"
            tooltipPosition="top"
          ></i>
        </span>
      </ng-template>
      <app-billing-control-subscriber-steps
        [step]="3"
        titleLabel="Pago"
        [paymentRoundId]="selectedRoundId"
        description="Step PAID (3): pagamento capturado; segue para ativação."
      />
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="billing-control__tab-header">
          <span class="billing-control__step-num billing-control__step-num--tab">5</span>
          Ativação
          <i
            class="pi pi-question-circle billing-control__help"
            [pTooltip]="tips.activation"
            tooltipPosition="top"
          ></i>
        </span>
      </ng-template>
      <app-billing-control-subscriber-steps
        [step]="4"
        titleLabel="Ativação"
        [paymentRoundId]="selectedRoundId"
        [initialMessageFilter]="stepMessageFilter"
        [showActivationFilters]="true"
        description="Step ACTIVATION (4): ativar a assinatura após o pagamento."
      />
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="billing-control__tab-header">
          <span class="billing-control__step-num billing-control__step-num--tab">6</span>
          Edição
          <i
            class="pi pi-question-circle billing-control__help"
            [pTooltip]="tips.edition"
            tooltipPosition="top"
          ></i>
        </span>
      </ng-template>
      <app-billing-control-subscriber-steps
        [step]="5"
        titleLabel="Edição"
        [paymentRoundId]="selectedRoundId"
        description="Step SUBSCRIBER_EDITION (5): criação da edição do mês (caixa)."
      />
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="billing-control__tab-header">
          <span class="billing-control__step-num billing-control__step-num--tab">7</span>
          Finalizado
          <i
            class="pi pi-question-circle billing-control__help"
            [pTooltip]="tips.finished"
            tooltipPosition="top"
          ></i>
        </span>
      </ng-template>
      <app-billing-control-subscriber-steps
        [step]="6"
        titleLabel="Finalizado"
        [paymentRoundId]="selectedRoundId"
        description="Step FINISHED (6): pessoas que já concluíram o ciclo nesta rodada."
      />
    </p-tabPanel>
  </p-tabView>

  <p-confirmPopup />
  <p-toast />
</div>
